import React from 'react';
import usePcrV2 from '../../hooks/usePcrV2';
import { useGetEpdElectricity } from 'services/api/queries';
import { ElectricityDataModel } from 'types/types';
import ElectricityGridPdf from './ElectricityGridPdf';

const ElectricityListPdf: React.FunctionComponent<{
  epdVersionId: string;
}> = ({ epdVersionId }) => {
  const electricityItems = useGetEpdElectricity(epdVersionId).data;
  const isPcrV2 = usePcrV2();

  const getElectricityHeaderText = (electricityUsedInProcessName: string | undefined, isDefaultElectricity: boolean) => {
    if (!isPcrV2) return 'Electricity used in the manufacturing process in A3';
    if (isDefaultElectricity) return 'Electricity used in the manufacturing process in A3 (A5 for services)';
    if (electricityUsedInProcessName) return `Electricity used in ${electricityUsedInProcessName}`;
    return 'Electricity used in unnamed process';
  };

  const hasElectricityItems = Array.isArray(electricityItems) && electricityItems.length > 0;

  if (!hasElectricityItems) return null;

  return electricityItems.map((electricityItem: ElectricityDataModel) => {
    const { electricityUsedInProcessName, isDefault } = electricityItem;
    const headerText = getElectricityHeaderText(electricityUsedInProcessName, isDefault);
    return <ElectricityGridPdf key={electricityItem.ord} headerText={headerText} data={electricityItem} isPcrV2={isPcrV2} />;
  });
};

export default ElectricityListPdf;
